import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';
import { ProcessingQueueService } from '../../services/processing-queue.service';
import {
  ProcessingQueueLookupRequest,
  ProcessingQueueLookupResponseItem
} from '../../models/processing-queue.models';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-processing-queue',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './processing-queue.component.html',
  styleUrls: ['./processing-queue.component.css'],
})
export class ProcessingQueueComponent implements OnInit {
  constructor(private processingQueueService: ProcessingQueueService, private cdr: ChangeDetectorRef) {
   
  }

  model: ProcessingQueueLookupRequest = {
    Page: 1,
    PageSize: 20,
    SearchText: '',
    ShowErrorsOnly: false,
    ShowGlobalListValues: true,
    ShowProducts: true,
    ShowVariants: true
  };
  
  items: ProcessingQueueLookupResponseItem[] = [];
  total: number = 0;
  totalFiltered: number = 0;
  totalPages: number = 0;
  currentItem: ProcessingQueueLookupResponseItem | null = null;

  ngOnInit(): void {
     this.loadItems();
  }

  loadItems(): void {
    this.processingQueueService.lookup(this.model).subscribe({
      next: (response) => {
        this.items = response.Items;
        this.total = response.Total;
        this.totalFiltered = response.TotalFiltered;
        this.totalPages = Math.floor((this.totalFiltered + this.model.PageSize - 1) / this.model.PageSize);

        if (this.model.Page > this.totalPages) {
            this.model.Page = 1;
        }
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
      }
    });
  }
  nextPage(): void {
    if (this.model.Page < this.totalPages) {
      this.model.Page++;
      this.loadItems();
    }
  }

  previousPage(): void {
    if (this.model.Page > 1) {
      this.model.Page--;
      this.loadItems();
    }
  }

  toggleShowErrorsOnly(): void {
    this.model.ShowErrorsOnly = !this.model.ShowErrorsOnly;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowGlobalListValues(): void {
    this.model.ShowGlobalListValues = !this.model.ShowGlobalListValues;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowProducts(): void {
    this.model.ShowProducts = !this.model.ShowProducts;
    this.model.Page = 1;
    this.loadItems();
  }

  toggleShowVariants(): void {
    this.model.ShowVariants = !this.model.ShowVariants;
    this.model.Page = 1;
    this.loadItems();
  }
}
